import React from "react";
import { useTranslation } from "react-i18next";

interface NoImageFeedbackProps {
  text?: string;
}

export function NoImageFeedback({
  text = "emptyImageText",
}: NoImageFeedbackProps) {
  const { t } = useTranslation("gallery");
  return (
    <div
      className="
        flex flex-col items-center justify-center
        w-full h-full
        bg-gray-100 text-gray-600
        rounded-md p-4
        box-border
      "
    >
      <svg
        className="w-16 h-16 mb-2 text-gray-400"
        fill="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z" />
      </svg>
      <p className="text-base">{t(text)}</p>
    </div>
  );
}
